export const AUTH_KEY = "flintly_user";
export const AUTH_ROLE_KEY = "flintly_role";

export function getUser(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(AUTH_KEY);
}

export function getUserRole(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(AUTH_ROLE_KEY);
}

export function setUser(username: string, role: string) {
  localStorage.setItem(AUTH_KEY, username);
  localStorage.setItem(AUTH_ROLE_KEY, role);
}

export function clearUser() {
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(AUTH_ROLE_KEY);
}
